import { DefaultTheme } from 'styled-components/dist/types';
import {
  deleteStyle,
  getValueFromStyles,
  updateStyles,
} from '../components/guides/Inspector/helpers';
import { getTypographyWeight } from '../components/shared/styled-components/constants';
import { defaultTransparent } from '../components/widgets/RichText/Config';
import { useGetThemesetColors } from '../queries/themesets';
import { TypographyChoice } from '../components/guides/Inspector/InspectorTypoPicker';

export const useCustomCSSEditor = style => {
  const customColors = [...useGetThemesetColors(), defaultTransparent];

  const findColorFromStyle = (property, selector?) => {
    return customColors?.find(
      color => color?.hexCode === getValueFromStyles(style, property, selector),
    );
  };

  const clearStyle = (property, selector?) => {
    const newStyle = deleteStyle(style, property, selector);
    return newStyle;
  };

  const addColorToStyle = (colorId, property, selector?) => {
    const selectedColor = customColors.find(color => color.id === colorId);
    let newStyle: string;
    if (selector) {
      newStyle = updateStyles(
        style,
        `${selector} {${property}: ${selectedColor?.hexCode}}`,
      );
    } else {
      newStyle = updateStyles(style, `${property}: ${selectedColor?.hexCode}`);
    }
    return newStyle;
  };

  const addValueToStyle = (value, property, selector?) => {
    let newStyle: string;
    const properties = Array.isArray(property) ? property : [property];
    const values = Array.isArray(value)
      ? value
      : Array(properties.length).fill(value);

    if (selector) {
      const propertyString = properties
        .map((prop, index) => `${prop}: ${values[index]}`)
        .join(';');
      newStyle = updateStyles(style, `${selector} {${propertyString}}`);
    } else {
      const propertyString = properties
        .map((prop, index) => `${prop}: ${values[index]}`)
        .join(';');
      newStyle = updateStyles(style, propertyString);
    }
    return newStyle;
  };

  const addTypographyToStyle = (theme: DefaultTheme, typography: TypographyChoice, selector?: string) => {
    let newStyle: string;
    const properties = ['font-family', 'font-weight'];
    const values = [
      `"${typography.fontFamily}"`,
      getTypographyWeight(theme, typography.fontFamily, typography.fontStyle),

    ];

    if (selector) {
      const propertyString = properties
        .map((prop, index) => `${prop}: ${values[index]}`)
        .join(';');
      newStyle = updateStyles(style, `${selector} {${propertyString}}`);
    } else {
      const propertyString = properties
        .map((prop, index) => `${prop}: ${values[index]}`)
        .join(';');
      newStyle = updateStyles(style, propertyString);
    }

    return newStyle;
  };

  const getValueFromStyle = (property, selector?) =>
    getValueFromStyles(style, property, selector);

  return {
    addTypographyToStyle,
    findColorFromStyle,
    clearStyle,
    addColorToStyle,
    addValueToStyle,
    getValueFromStyle,
  };
};
